import React, { useEffect, useState } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { getCities, getStates } from '../../api/states';

export const Formsede = ({ dataSede, Enviar, dataDefault }) => {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const isPrincipal = dataDefault?.nameSede === 'Principal';

  // Cargar departamentos al montar
  useEffect(() => {
    getStates()
      .then((r) => r.json())
      .then((data) => setStates(data))
      .catch(() => {});
  }, []);

  // Cargar ciudades cuando cambia el departamento
  useEffect(() => {
    if (!dataDefault?.departamento) {
      setCities([]);
      return;
    }
    getCities(dataDefault.departamento)
      .then((r) => r.json())
      .then((data) => setCities(data))
      .catch(() => setCities([]));
  }, [dataDefault?.departamento]);

  const handleSubmit = (e) => {
    e.preventDefault();
    Enviar();
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col md={12}>
          <Form.Group>
            <Form.Label>Nombre de Sede *</Form.Label>
            <Form.Control
              required
              name="nameSede"
              onChange={dataSede}
              defaultValue={dataDefault?.nameSede}
              disabled={isPrincipal}
              placeholder="Ej: Bogotá Norte"
            />
            {isPrincipal && (
              <Form.Text className="text-muted">
                La sede Principal no puede renombrarse.
              </Form.Text>
            )}
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Departamento *</Form.Label>
            <Form.Select
              name="departamento"
              defaultValue={dataDefault?.departamento || ''}
              onChange={(e) => {
                dataSede(e);
                // Limpiar ciudad al cambiar depto
                getCities(e.target.value)
                  .then((r) => r.json())
                  .then((data) => setCities(data))
                  .catch(() => setCities([]));
              }}
            >
              <option value="">-- Selecciona --</option>
              {states.map((s, idx) => (
                <option key={idx} value={s.name}>{s.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Ciudad *</Form.Label>
            <Form.Select
              name="ciudad"
              defaultValue={dataDefault?.ciudad || ''}
              onChange={dataSede}
              disabled={cities.length === 0}
            >
              <option value="">-- Selecciona --</option>
              {cities.map((c, idx) => (
                <option key={idx} value={c.name}>{c.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={12}>
          <Form.Group>
            <Form.Label>Dirección *</Form.Label>
            <Form.Control
              required
              name="dirSede"
              onChange={dataSede}
              defaultValue={dataDefault?.dirSede}
              placeholder="Ej: Cra 15 # 40-20"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Persona de Contacto</Form.Label>
            <Form.Control
              name="contSede"
              onChange={dataSede}
              defaultValue={dataDefault?.contSede}
              placeholder="Nombre del contacto"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Teléfono</Form.Label>
            <Form.Control
              name="celContacto"
              onChange={dataSede}
              defaultValue={dataDefault?.celContacto}
              placeholder="Ej: 3001234567"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={12}>
          <Form.Group>
            <Form.Label>Correo</Form.Label>
            <Form.Control
              type="email"
              name="emailContacto"
              onChange={dataSede}
              defaultValue={dataDefault?.emailContacto}
              placeholder="correo@empresa.com"
            />
          </Form.Group>
        </Col>
      </Row>

      <Button type="submit" variant="primary" className="w-100">
        Guardar
      </Button>
    </Form>
  );
};


